import { WarningTwoIcon } from '@chakra-ui/icons';
import {
  Table,
  TableContainer,
  Tbody,
  Thead,
  Tr,
  Td,
  ButtonGroup,
  Button,
  Text,
  useDisclosure,
  Checkbox,
  useToast,
  VStack,
  Spacer,
  Flex,
  Heading,
  Image,
  HStack,
} from '@chakra-ui/react';
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AccountContext } from '../../AccountContext';
import _ from 'lodash';
import Loading from 'components/Loading';
import PagamentoLocalizado from 'components/Pagamento/PagamentoLocalizado';
import Desconto from '../../../images/Desconto.svg';
import { FaCircleInfo } from 'react-icons/fa6';
import { api } from 'api/api';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const REACT_APP_DEOVITA_RECIPIENT_ID =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_DEOVITA_RECIPIENT_ID_PROD
    : process.env.REACT_APP_DEOVITA_RECIPIENT_ID_TEST;
function ListaParcelas(props) {
  const navigate = useNavigate();
  const { user, page, setPage, setUser } = useContext(AccountContext);
  useEffect(() => {
    setPage('Parcelas');
  }, []);

  const [selecionados, setSelecionados] = useState([]);
  const [valor_selecionado, setValorSelecionado] = useState(0);
  const [valor_desconto, setValorDesconto] = useState(0);
  const [isToastActive, setIsToastActive] = useState(false);
  const status = props?.status;
  const motivo = props?.motivo;
  const [parcelas, setParcelas] = useState(props.parcelas ? props.parcelas : []);

  async function fetchStatusParcelas() {
    try {
      const recipientsIds = parcelas.filter((parcela) => parcela.id_transaction).map((parcela) => parcela.id_transaction);

      const response = await api(`${ENDPOINT}/clients/fetchStatusParcelas`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ parcelas: recipientsIds }),
      });

      if (!response.ok) {
        console.log('Erro na resposta: ', response);
        return;
      }
      const responseData = await response.json();
      const updatedParcelas = parcelas.map((parcela) => {
        const matchingResponse = responseData.find((item) => item.id === parcela.id_transaction);
        return matchingResponse ? { ...parcela, status: matchingResponse.status } : parcela;
      });

      const filteredParcelas = updatedParcelas.filter(
        (parcela) => (parcela.status !== 'failed' || parcela.status !== 'paid') && parcela.id_transaction
      );

      setParcelas(updatedParcelas);
      setUser((prevState) => ({
        ...prevState,
        pesquisaParcelasPendentes: filteredParcelas,
      }));
    } catch (error) {
      console.error('Erro ao buscar status das parcelas: ', error);
    }
  }

  useEffect(() => {
    fetchStatusParcelas();
  }, []);

  const url = `${ENDPOINT}/client/parcelas`;
  const { id_contrato, descricao_plano, titular } = user;
  const [todosMarcados, setTodosMarcados] = useState(false);
  const valor_a_pagar = user && user.qntdeParcelas && user.qntdeParcelas.valorParcelas ? user.qntdeParcelas.valorParcelas : null;

  function containsObject(object, list) {
    return list.some((item) => item.parcela_id === object.parcela_id);
  }

  const checkboxValues = (object) => {
    const index = selecionados.findIndex((item) => item.parcela_id === object.parcela_id);
    if (index !== -1) {
      setSelecionados(selecionados.filter((item) => item.parcela_id !== object.parcela_id));
    } else {
      setSelecionados([...selecionados, object]);
    }
  };

  const toast = useToast({
    title: 'Aviso',
    description: 'Selecione no mínimo uma parcela',
    status: 'info',
    duration: 2000,
    position: 'bottom',
    colorScheme: 'red',
    containerStyle: {
      paddingTop: '50px',
    },
  });

  const enviarPagamento = () => {
    let split = [];
    if (user?.clienteImportado?.clientImportado === true || user?.clienteImportado?.clientImportado === 'true') {
      const parcelaComTaxaAdesao = parcelas ? parcelas?.find((parcela) => parcela.taxa_adesao === true) : null;
      const vendedorAmount = parcelaComTaxaAdesao?.split_vendedor || 0;
      const deovitaAmount = 100 - vendedorAmount;
      split = [
        {
          // Vendedor
          amount: vendedorAmount ? Math.round(vendedorAmount) : vendedorAmount,
          recipient_id: `${user?.clienteImportado?.empreendedor?.recipient_id_pagarme}`,
          type: 'percentage',
          options: {
            charge_processing_fee: false,
            charge_remainder_fee: false,
            liable: false,
          },
        },
        {
          // Deovita
          amount: deovitaAmount,
          recipient_id: REACT_APP_DEOVITA_RECIPIENT_ID,
          type: 'percentage',
          options: {
            charge_processing_fee: true,
            charge_remainder_fee: true,
            liable: true,
          },
        },
      ];
    }

    if (valor_selecionado >= 1.0) {
      const data = {
        paciente_id: user.id_cliente_deovita,
        username: user.name,
        parcelsActive: true,
        paciente_contrato_id: user.titular ? user.id_contrato : user.id_contrato_dependent.paciente_contrato_id,
        valor:
          valor_selecionado >= 1.0 && valor_desconto >= 1.0 && status === 'cancelamento_contrato' && user.id_forma_pagamento !== 13
            ? valor_desconto
            : valor_selecionado,
        valor_desconto: valor_desconto,
        status: status,
        expiration_pix_in_min: 5,
        navig_to: status === 'cancelamento_contrato' ? '/perfil/assinaturas/contrato-cancelado-sucesso' : '/perfil/dependentes/processar-pagamento',
        item: {
          paciente_id: user.id_cliente_deovita,
          descricao: 'Pagamento parcelas em atraso',
          paciente_contrato_parcelas_id: selecionados.map((item) => ({
            parcela_id: item.parcela_id,
            valor: item.valor,
            valor_desconto: item.valor_desconto,
          })),
          paciente_contrato_id: user.titular ? user.id_contrato : user.id_contrato_dependent.paciente_contrato_id,
          valor: valor_selecionado,
          valor_desconto: valor_desconto,
          status: status,
          whatsapp: user.phone1 || user.phone2,
          nome: user.name,
          valor_pendente: user?.qntdeParcelas?.valorParcelas,
          motivo: status === 'cancelamento_contrato' ? props?.motivo : '',
          desconto:
            valor_selecionado >= 1.0 && valor_desconto >= 1.0 && status === 'cancelamento_contrato' && user.id_forma_pagamento !== 13 ? true : false,
          pagamentoAdesao: user?.clienteImportado?.clientImportado === true || user?.clienteImportado?.clientImportado === 'true' ? true : false,
          dadosClienteImportado:
            user?.clienteImportado?.clientImportado === true || user?.clienteImportado?.clientImportado === 'true' ? user?.clienteImportado : null,
          split: split ? [...split] : null,
          split_rules: split ? [...split] : null,
        },
        orientacoes: '',
        service: 'settle_the_debt',
        confim: true,
        arrayPagamento: selecionados,
        split: split,
        frequenciaText: 'Pagamento de dívida'
      };
      navigate('/pagamentos', { state: data });
    } else {
      toast();
    }
  };

  function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  useEffect(() => {
    if (todosMarcados) {
      const dadosParcelas = checkboxValues(
        parcelas.map((parcela) => ({
          parcela_id: parcela.paciente_contrato_parcelas_id,
          valor: parcela.valor,
          valor_desconto: parcela.valor * 0.5,
        }))
      );
      setValorSelecionado(user?.qntdeParcelas?.valorParcelas);
      return;
    }

    if (!todosMarcados) {
      setValorSelecionado(0);
      return;
    }
  }, [todosMarcados]);

  useEffect(() => {
    let valorSomado = 0;
    selecionados.forEach((selecionado) => {
      const valorFloat = parseFloat(selecionado.valor);
      if (!isNaN(valorFloat)) {
        valorSomado += valorFloat;
      }
    });
    setValorSelecionado(valorSomado);

    const clienteSelecionouMetadeOuMais = selecionados?.length >= parcelas.length / 2;

    if (!clienteSelecionouMetadeOuMais) {
      setValorDesconto(0);
    } else {
      const valorComDesconto = valorSomado * 0.5;
      setValorDesconto(valorComDesconto);
    }
  }, [selecionados, parcelas]);
  console.log(parcelas)
  const handleMasterCheckboxChange = () => {
   
    setTodosMarcados(!todosMarcados);
    if (!todosMarcados) {
      setSelecionados(
        parcelas
          .filter((parcela) => parcela.status !== 'pending' && parcela.status !== 'paid')
          .map((parcela) => ({
            parcela_id: parcela.paciente_contrato_parcelas_id,
            valor: parcela.valor,
            valor_desconto: parcela.valor * 0.5,
          }))
      );
    } else {
      setSelecionados([]);
    }
  };

  function callToast(title, descricao) {
    toast({
      title: title,
      description: descricao,
      duration: 4000,
      isClosable: true,
      position: 'bottom',
      colorScheme: 'teal',
      containerStyle: {
        paddingTop: '50px',
      },
    });
  }

  const useParcelas = parcelas.map((parcela, index) => {
    console.log("parcela ", parcela)
    const data = parcela.data;
    const formData = new Date(data ? data.replace(' ', 'T') : '');
    const mesPorExtenso = formData.toLocaleDateString('pt-BR', { month: 'long' });
    const vals = { parcela_id: parcela.paciente_contrato_parcelas_id, valor: parcela.valor };
    const statusPagamento =
      !parcela.status || parcela.status === 'failed'
        ? 'Pendente'
        : parcela.status === 'pending'
        ? 'Processando'
        : parcela.status === 'paid'
        ? 'Paga'
        : '';
    return (
      <Tr key={index}>
        <Td>
          {parcela.data === null || parcela.data === '' || parcela.data === undefined ? (
            <WarningTwoIcon color="orange" />
          ) : (
            <WarningTwoIcon color="white" />
          )}
          <HStack ml={'1em'}>
            <span
              style={{
                color: 'white',
                borderRadius: '0.8em',
                backgroundColor: !parcela.status || parcela.status === 'pending' ? 'orange' : parcela.status === 'paid' ? 'green' : 'red',
                padding: '0.3em',
              }}
            >
              {statusPagamento}
            </span>
            <FaCircleInfo
              color={'grey'}
              onClick={() => {
                let message =
                  parcela.status === 'failed'
                    ? 'O pagamento não foi concluído com sucesso. Por favor, tente novamente ou entre em contato com nosso suporte para assistência.'
                    : parcela.status === 'pending'
                    ? 'Seu pagamento está em processamento. Aguarde a confirmação ou fale com nosso suporte se precisar de ajuda.'
                    : parcela.status === 'paid'
                    ? 'Pagamento recebido com sucesso! Agradecemos sua preferência.'
                    : 'Aguardando pagamento desta parcela. Se tiver dúvidas, estamos à disposição no suporte.';
                callToast(statusPagamento, message);
              }}
            />{' '}
          </HStack>
          <Text fontSize="16px" color={'#585858'} ml={'1em'} mt={2}>
            Assinatura Mensal - <br />
            plano {String(descricao_plano).charAt(0).toUpperCase() + String(descricao_plano).slice(1).toLowerCase()} (
            {capitalizeFirstLetter(mesPorExtenso)})
          </Text>
        </Td>

        <Td>
          {parcela.valor === null || parcela.valor === '' || parcela.valor === undefined ? (
            <WarningTwoIcon color="orange" />
          ) : (
            <WarningTwoIcon color="white" />
          )}
          <Text fontSize="16px" color={'#585858'} ml={'1em'} fontWeight={'bold'}>
            R${' ' + parcela.valor}
          </Text>
        </Td>

        <Td>
          <Text fontSize="16px" color={'#585858'} ml={'1em'}>
            <Checkbox
              name="paciente_contrato_parcelas_id"
              borderRadius={'0.8em'}
              iconColor="green.100"
              colorScheme="green"
              value={vals}
              bg={'#E4E4E4'}
              onChange={(e) => checkboxValues({ parcela_id: parcela.paciente_contrato_parcelas_id, valor: parcela.valor })}
              isChecked={selecionados.some((item) => item.parcela_id === parcela.paciente_contrato_parcelas_id)}
              disabled={parcela.status === 'pending' || parcela.status === 'paid' ? true : false}
            ></Checkbox>
          </Text>
        </Td>
      </Tr>
    );
  });

  async function fetchMensalidades() {
    setIsToastActive(false);
    toast.closeAll();
    const toastId = toast({
      title: 'Carregando',
      description: 'Aguarde... Estamos carregando as informações.',
      status: 'warning',
      isClosable: true,
      position: 'bottom',
      colorScheme: 'red',
      duration: null,
      type: 'loading',
      containerStyle: {
        paddingTop: '50px',
      },
    });

    const response = await api(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({
        id_contrato: user?.clienteImportado?.clientImportado ? user?.clienteImportado?.empreendedor?.contrato_id : user.id_contrato,
        titular: user.titular,
        id_contrato_dependente: user.id_contrato_dependent,
        adesaoImportada: user?.clienteImportado?.clientImportado,
      }),
    });
    await response.json().then(async (postsData) => {
      toast.close(toastId);
      if (postsData?.length === 0) {
        navigate('/dashboard/financeiro/sucesso-pagamento');
      } else {
        if (valor_selecionado >= '1.00') {
          enviarPagamento();
        } else {
          toast();
        }
      }
    });
  }

  return (
    <>
      <VStack m="5%" spacing={3} align="start">
        <Text fontWeight="bold" fontSize="16px" color={'#585858'} mt={'1em'}>
          Selecione quais os itens pendentes você irá pagar
        </Text>
        <TableContainer
          minWidth="100%"
          style={{ maxWidth: '100%', maxHeight: '300px', overflow: 'auto', border: '2px solid #E4E4E4', borderRadius: '1em' }}
        >
          <Text fontWeight="bold" fontSize="16px" color={'#585858'} mt={'1em'} ml={'1em'}>
            Pagamentos pendentes
          </Text>
          <Table>
            <Tbody>
              <Tr>
                <Td>
                  <Text fontSize="16px" color={'#585858'} ml={'1em'}>
                    Selecionar todos os itens
                  </Text>
                  <p></p>
                </Td>
                <Td>
                  <Text fontSize="16px" color={'#585858'} ml={'1em'}></Text>
                </Td>
                <Td>
                  {' '}
                  <Text fontSize="16px" color={'#585858'} ml={'1em'}>
                    <Checkbox
                      name="paciente_contrato_parcelas_id"
                      borderRadius={'0.8em'}
                      iconColor="green.100"
                      colorScheme="green"
                      bg={'#E4E4E4'}
                      onChange={handleMasterCheckboxChange}
                      isChecked={todosMarcados}
                    ></Checkbox>
                  </Text>
                </Td>
              </Tr>
            </Tbody>
            <Tbody>{parcelas && useParcelas}</Tbody>
          </Table>
        </TableContainer>
        <Text fontWeight="bold" fontSize="16px" color={'#585858'} mt={'1em'}>
          Total:
          {valor_selecionado >= 1.0 && valor_desconto >= 1.0 && status === 'cancelamento_contrato' && user.id_forma_pagamento !== 13 ? (
            <span style={{ color: 'orange' }}> R$ {valor_desconto.toFixed(2)} (50%)</span>
          ) : (
            ' R$ ' + valor_selecionado.toFixed(2)
          )}
        </Text>
      </VStack>
      {status === 'cancelamento_contrato' && user.id_forma_pagamento !== 13 ? (
        <>
          <VStack w={'80%'} bg={'#5AB2AE'} p={'1em'} borderRadius={'0.8em'} alignItems="flex-start">
            <Image boxSize="20px" objectFit="cover" src={Desconto} />
            <Heading fontSize={'19px'} color={'white'} fontWeight={'bold'} textAlign="left">
              Tenha 50% de desconto!
            </Heading>
            <Text fontSize={'14px'} color={'white'} textAlign="left">
              Selecionando metade dos pagamentos pendentes, você adquire 50% de desconto no pagamento de suas parcelas pendentes!
            </Text>
          </VStack>
        </>
      ) : (
        <></>
      )}
      {valor_selecionado >= '1.00' ? (
        <>
          <ButtonGroup>
            <Button
              name="btn"
              backgroundColor={user.id_contrato ? '#5AB2AE' : '#5AB2AE'}
              variant="outline"
              onClick={() => {
                fetchMensalidades();
              }}
              w={{
                base: '100%',
              }}
              color={'white'}
            >
              Realizar pagamento
            </Button>
          </ButtonGroup>
        </>
      ) : (
        <></>
      )}
      <Spacer></Spacer> <Spacer></Spacer>
    </>
  );
}

export default ListaParcelas;
